import Button from 'shared/buttons';
import React, { useState } from 'react';
import { FormTextArea } from 'shared/formControls';
import CustomSearchEntityDropdown from 'shared/dropdowns/CustomSearchEntityDropdown';
import CustomerSearchEntityFieldsDropdown from 'shared/dropdowns/CustomerSearchEntityFieldsDropdown';
import { searchOrders } from 'src/fetch/orders';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { useLocation } from 'react-router-dom';

const CustomSearchModal = ({ onSearchSuccess }) => {

    const [searchTerm, setSearchTerm] = useState('');
    const [view, setView] = useState('orders')
    const [field, setField] = useState('ProNumber');
    const history = useHistory();
    const location = useLocation();

    const viewHandlers = {
        orders: {
            retrieveData: () => searchOrders({
                fieldTerms: {
                    [field?.value || field]: searchTerm
                }
            }),
            onSuccess: (data) => {


                if (data?.length === 1) {
                    const proNumber = data[0].proNumber;

                    history.push(`/orders/orders/${proNumber}`);
                    return;
                }

                const filter = data?.length ? {
                    logic: 'or',
                    filters: data.map(({ proNumber }) => ({
                        operator: 'eq',
                        fieldInfo: {
                            name: 'ProNumber',
                            metadata: {
                                collection: false
                            },
                            nestedField: null
                        },
                        value: proNumber
                    }))
                } : {
                    logic: 'or',
                    filters: [
                        {
                            operator: 'eq',
                            fieldInfo: {
                                name: 'ProNumber',
                                metadata: {
                                    collection: false
                                },
                                nestedField: null
                            },
                            value: -1
                        }
                    ]
                }

                window.sessionStorage.setItem('orders.filter', JSON.stringify({ expression: filter, hidden: true }));

                if (location.pathname === '/orders/orders') {
                    window.location.reload();
                } else {
                    history.push('/orders/orders');
                }

            }
        }
    }

    const handleSearch = async () => {

        const { retrieveData, onSuccess } = viewHandlers[view];

        const data = await retrieveData();
        onSuccess(data);
        onSearchSuccess?.();
    }

    return (
        <>
            <FormTextArea rows={20} placeholder='' onChange={({ value }) => setSearchTerm(value)} fillMode='solid' />
            <div style={{ marginTop: '20px', display: 'flex' }} >
                <CustomerSearchEntityFieldsDropdown label='Search By' value={field} onChange={({ value }) => setField(value)} />
                <CustomSearchEntityDropdown label='View' value={view} />
                <Button
                    icon='search'
                    title='Search'
                    disabled={!searchTerm?.length}
                    style={{ marginTop: '32px', marginLeft: '10px' }}
                    onClick={handleSearch}
                />
            </div>

        </>
    )
}

export default CustomSearchModal;